import React, { useCallback, useEffect, useState } from "react";
import { ArrowsSplit, Plus } from "@phosphor-icons/react";
import api from "@/lib/api";
import { RotatorForm } from "./RotatorForm";
import { RotatorCard } from "./RotatorCard";

export function RotatorLinks() {
  const [data, setData] = useState(null);
  const [adding, setAdding] = useState(false);
  const load = useCallback(() => {
    api.get("/vendor/rotators").then((r) => setData(r.data)).catch(() => setData({ items: [], pages: [], error: true }));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <section className="brut-card p-4 md:p-5 mb-6" data-testid="rotator-links">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        <ArrowsSplit size={16} weight="bold" />
        <h2 className="font-chivo font-black uppercase tracking-tighter">Rotating links (A/B test)</h2>
        {data && !adding && (
          <button type="button" onClick={() => setAdding(true)} data-testid="rotator-new-btn"
                  className="sm:ml-auto border-2 border-black bg-black text-white px-2.5 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 hover:bg-zinc-800">
            <Plus size={11} weight="bold" /> New rotating link
          </button>
        )}
      </div>
      <p className="text-xs text-zinc-600 mb-3">
        One link that rotates visitors across the pages you pick, finds the page with the most form submissions per visit, and keeps sending traffic to the winner.
      </p>
      {!data && <div className="label-mono">Loading…</div>}
      {data?.error && <div className="text-xs text-red-700" data-testid="rotator-error">Couldn&apos;t load your rotating links.</div>}
      {adding && <div className="mb-3"><RotatorForm pages={data.pages} onSaved={() => { setAdding(false); load(); }} onCancel={() => setAdding(false)} /></div>}
      {data && !data.error && (
        <div className="flex flex-col gap-3">
          {data.items.map((r) => <RotatorCard key={r.id} r={r} pages={data.pages} onChanged={load} />)}
          {!data.items.length && !adding && <div className="text-xs text-zinc-500" data-testid="rotator-empty">No rotating links yet.</div>}
        </div>
      )}
    </section>
  );
}
